import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import FeedbackFormMentee from './FeedbackFormMentee';
import FeedbackFormMentor from './FeedbackFormMentor';

export default function FeedbackPage() {
  const [params] = useSearchParams();
  const { i18n } = useTranslation();

  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invalid, setInvalid] = useState(false);
  const [mentorSubmitError, setMentorSubmitError] = useState('');

  // URL-Parameter aus dem Link
  const uid = params.get('uid');
  const milestone = params.get('milestone');
  const menteeId = params.get('mentee_id');   // für Mentor-Feedback
  const mentorId = params.get('mentor_id');   // für Mentee-Feedback (shared_goals/competences)
  const roleParam = params.get('role');
  const lang = params.get('lang');

  // Sprache aus dem Link setzen (de/en)
  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // Rolle bestimmen (mentor/mentee)
  useEffect(() => {
    if (!uid || !milestone) {
      setInvalid(true);
      setLoading(false);
      return;
    }

    const validRoles = ['mentor', 'mentee'];

    if (validRoles.includes(roleParam)) {
      setRole(roleParam);
      setLoading(false);
      return;
    }

    async function fetchUserRole() {
      try {
        const res = await axios.get(`/mentoring/user-role/${uid}`);
        setRole(res.data.role);
      } catch (err) {
        setInvalid(true);
      } finally {
        setLoading(false);
      }
    }

    fetchUserRole();
  }, [uid, milestone, roleParam]);

  if (loading) {
    return <div className="text-white p-6">Lade...</div>;
  }

  if (invalid || !role) {
    return (
      <div className="text-red-500 p-6">
        Ungültiger Link oder Benutzer nicht gefunden
      </div>
    );
  }

  // Mentor:innen-Feedback absenden
  const handleMentorFeedbackSubmit = async (data) => {
    setMentorSubmitError('');
    try {
      await axios.post(
        '/mentoring/assessment',
        {
          user_id: parseInt(uid, 10),
          role: 'mentor',
          milestone,
          source: 'reminder',
          target_user_id: parseInt(menteeId, 10),
          criteria: data.criteria,
          satisfaction_score: data.satisfaction_score,
          comments: data.comments,
        },
        { withCredentials: true }
      );
      // Erfolgs-Handling im Formular selbst
    } catch (err) {
      setMentorSubmitError('Fehler beim Speichern. Bitte erneut versuchen.');
    }
  };

  return (
    <div className="min-h-screen bg-black text-white p-6">
      <h1 className="text-3xl font-bold mb-4">
        Dein Feedback zum Mentoring ({milestone})
      </h1>

      {role === 'mentor' ? (
        <>
          {mentorSubmitError && (
            <div className="text-red-500 mb-3">{mentorSubmitError}</div>
          )}
          <FeedbackFormMentor
            userId={parseInt(uid, 10)}
            targetUserId={parseInt(menteeId, 10)}
            milestone={milestone}
            source="reminder"
            onSubmit={handleMentorFeedbackSubmit}
          />
        </>
      ) : (
        <FeedbackFormMentee
          userId={parseInt(uid, 10)}
          mentorId={mentorId ? parseInt(mentorId, 10) : undefined}
          milestone={milestone}
          source="reminder"
        />
      )}
    </div>
  );
}

